// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__tYU1c"};